import type { IconDef } from '../types';

export const cup: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M20.0962 1H3.96621C2.81621 1 1.91621 1.98 2.00621 3.13L2.15621 4.85C2.22621 5.68 2.80621 6.34 3.56621 6.56L5.03621 21.24C5.13621 22.24 5.97621 23 6.98621 23H17.2462C18.2562 23 19.0962 22.24 19.1962 21.24L20.6762 6.46C21.2762 6.19 21.7262 5.62 21.8162 4.93L22.0362 3.21C22.1862 2.04 21.2762 1 20.0962 1ZM17.2162 21H7.02621L6.88621 19.6H9.32621C9.85621 19.6 10.2862 19.17 10.2862 18.64C10.2862 18.11 9.85621 17.68 9.32621 17.68H6.69621L6.45621 15.28H9.32621C9.85621 15.28 10.2862 14.85 10.2862 14.32C10.2862 13.79 9.85621 13.36 9.32621 13.36H6.26621L6.02621 10.96H9.32621C9.85621 10.96 10.2862 10.53 10.2862 10C10.2862 9.47 9.85621 9.04 9.32621 9.04H5.83621L5.59621 6.64H18.6562L17.2162 21ZM19.8462 4.64H4.14621L4.00621 3H20.0462L19.8362 4.64H19.8462Z',
    },
  ],
};
